import { request } from "@/service/request.js";

export function getInvoiceApplyList(options) {
  return request.call(this, {
      url: "/openapi/web/invoice/apply/list",
      method: 'POST',
      data:options
  });
};


export function getInvoiceOrderList(options) {
  return request.call(this, {
      url: "/openapi/web/invoice/available/order/list",
      method: 'POST',
      data:options
  });
};
